import { idb } from "utils"
import { store } from "@redux"

import * as types from "../types/foodSpecificationsMap"
import { getAllFoodSpecifications } from "services"

export const fetchFoodSpecifications = () => (
  async (dispatch) => {
    const branchId =
      store.getState().userAccountInfo.branchId

    try {
      const specificationsFromDatabase =
        await idb.getAllItemsFromDatabase(
          branchId,
          "foodSpecifications"
        )

      dispatch({
        type: types.ADD_FOOD_SPECIFICATIONS,
        specifications: specificationsFromDatabase
      })

      const response =
        await getAllFoodSpecifications({ skip: 0, limit: 100 })

      dispatch({
        type: types.ADD_FOOD_SPECIFICATIONS,
        specifications: response
      })

      idb.saveItemsToDatabase(
        branchId,
        "foodSpecifications",
        response
      )
    } catch (err) {
      console.log(err)
    }
  }
)

export const addFoodSpecifications = (specifications) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "foodSpecifications",
    specifications
  )

  return {
    type: types.ADD_FOOD_SPECIFICATIONS,
    specifications
  }
}

export const updateFoodSpecifications = specifications => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "foodSpecifications",
    specifications
  )

  return {
    type: types.UPDATE_FOOD_SPECIFICATIONS,
    specifications
  }
}

export const deleteFoodSpecifications = (specificationIds) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.deleteItemsFromDatabase(
    branchId,
    "foodSpecifications",
    specificationIds
  )

  return {
    type: types.DELETE_FOOD_SPECIFICATIONS,
    specificationIds
  }
}

export const clearFoodSpecifications = () => ({
  type: types.CLEAR_FOOD_SPECIFICATIONS
})